module.exports = __webpack_public_path__ + "static/media/icon_54.429fc3c3.svg";